module.exports = __webpack_public_path__ + "media/images/design/images/h2_pickup-a131d05d09bc3e0d83fe443390d097b0.png";